import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DiscoverFilterBar, InterestFilter} from '../../../../../models/filter-search';
import {DiscoverInterestFilter} from '../../../../../models/discover';
import {AchooSliderComponent} from '../../../../core/achoo-slider/achoo-slider.component';
import { AchooFilterBoxComponent } from '../../../../core/achoo-filter-box/achoo-filter-box.component';
import {FilterRange} from '../../../../../models/group-search';

@Component({
  selector: 'interest-filter',
  templateUrl: './interest-filter.component.html',
  styleUrls: ['./interest-filter.component.scss']
})
export class InterestFilterComponent implements OnInit {
  static readonly minSearchValue = 0;
  static readonly maxSearchValue = 100;
  @ViewChild('topicFilterBox')
  topicFilterBox: AchooFilterBoxComponent;
  @ViewChild('topicRangeSlider')
  topicRangeSlider: AchooSliderComponent;
  @ViewChild('industriesFilterBox')
  industriesFilterBox: AchooFilterBoxComponent;
  @ViewChild('industrieseRangeSlider')
  industrieseRangeSlider: AchooSliderComponent;
  @Input()
  public discoverFilterBar: DiscoverFilterBar;
  @Input()
  public interestFilter: DiscoverInterestFilter;
  @Output()
  public searchByInterestFilter = new EventEmitter<DiscoverInterestFilter>();
  @Output()
  public clearInterestFilterEvent = new EventEmitter<DiscoverInterestFilter>();
  @Output()
  public hideInterestFilterEvent = new EventEmitter<DiscoverInterestFilter>();

  public minValue = InterestFilterComponent.minSearchValue;
  public maxValue = InterestFilterComponent.maxSearchValue;
  public fromTopic;
  public fromIndustry;
  public toTopic;
  public toIndustry;

  ngOnInit() {
    if (!this.interestFilter) {
      this.initInterestFilterValues();
    } else {
      this.fromTopic = this.interestFilter.topicPercentage.range.from;
      this.toTopic = this.interestFilter.topicPercentage.range.to;
      this.fromIndustry = this.interestFilter.topIndustries.range.from;
      this.toIndustry = this.interestFilter.topIndustries.range.to;
    }
  }

  doSearchByInterestFilter() {
    this.searchByInterestFilter.emit(this.interestFilter);
  }

  resetInterestFilters() {
    // reset criteria
    this.initInterestFilterValues();
    // reset slider element
    this.topicRangeSlider.resetSlider();
    this.topicRangeSlider.sliderElement.reset();
    this.industrieseRangeSlider.resetSlider();
    this.industrieseRangeSlider.sliderElement.reset();
    // emit event clear
    this.clearInterestFilterEvent.emit(this.interestFilter);
  }

  onClickedOutside(e) {
    this.hideInterestFilterEvent.emit(this.interestFilter);
  }

  private initInterestFilterValues() {
    this.interestFilter = new DiscoverInterestFilter();
    this.interestFilter.topicPercentage.range = new FilterRange(InterestFilterComponent.minSearchValue, InterestFilterComponent.maxSearchValue);
    this.interestFilter.topIndustries.range = new FilterRange(InterestFilterComponent.minSearchValue, InterestFilterComponent.maxSearchValue);
    this.fromTopic = this.fromIndustry = InterestFilterComponent.minSearchValue;
    this.toTopic = this.toIndustry = InterestFilterComponent.maxSearchValue;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/discover/discover-search/interest-filter/interest-filter.component.ts